<template>
  <div class="menu-block-wrapper">
    <div class="parent-menu-wrapper">
      <a
        v-if="!hasChild"
        class="parent-menu"
        :href="menu.path"
      >
        {{ menu.displayName }}
      </a>
      <span
        class="parent-menu"
        v-else
      >
        {{ menu.displayName }}
      </span>
    </div>
    <div class="menu-children">
      <a
        :href="`${item.isRootPath ? item.path :menu.path + (item.path || '')}`"
        v-for="(item, index) in menu.children"
        class="child-menu"
        :key="index"
        @click="onClick($event, item)"
      >
        {{ item.displayName }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuBlock',

  props: {
    menu: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasChild () {
      return (this.menu.children || []).length > 0;
    },
  },

  methods: {
    onClick (event, item) {
      if (item.onClick) {
        event.preventDefault();
        item.onClick();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .menu-block-wrapper {
    margin-top: 60px;

    &:not(:last-child) {
      margin-right: 60px;
    }

    .parent-menu-wrapper {
      margin-bottom: 10px;

      .parent-menu {
        color: #273142;
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 30px;
      }
    }

    .menu-children {

      .child-menu {
        color: #273142;
        font-weight: 500;
        display: block;
        padding: 15px 0;

        &:not(:last-child) {
          border-bottom: 1px solid #f1f2f7;
        }
      }
    }
  }

</style>
